import React, { useMemo, useRef, useEffect, useState } from "react";
import * as THREE from "three";

function Sky() {
  const [texture, setTexture] = useState<THREE.Texture | null>(null);
  const sphereRef = useRef<THREE.Mesh>(null);

  useEffect(() => {
    const loader = new THREE.TextureLoader();
    loader.load("/images/textures/sky.png", (loadedTexture) => {
      setTexture(loadedTexture);
    });
  }, []);

  // Return null if the texture is not yet loaded
  if (!texture) return null;

  return (
    <mesh ref={sphereRef}>
      {/* Large sphere with high segments to represent the sky */}
      <sphereGeometry args={[500, 100, 100]} />
      <meshBasicMaterial
        map={texture} // Apply the loaded texture
        side={THREE.BackSide} // Ensure the texture is applied to the inside of the sphere
        fog={false} // Disable fog for the sky
      />
    </mesh>
  );
}

export default Sky;
